"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const theme_1 = __importDefault(require("../../styles/theme"));
const react_1 = require("@emotion/react");
const layout_1 = require("../layout");
/**
 * Placeholder UI element with animated dots
 */
const SkeletonContainer = styled_1.default.div({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gridColumn: 'span 2',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme_1.default.colors.grey05,
});
const blink = (0, react_1.keyframes) `
    from {
        opacity: .2;
    }
    50% {
        opacity: 1;
    }
    to {
        opacity: .2;
    }
`;
const BlinkingDot = styled_1.default.div({
    width: '16px',
    height: '16px',
    backgroundColor: 'rgba(63, 103, 139)',
    overflow: 'visible',
    borderRadius: '50%',
    margin: '0 8px',
    animation: `${blink} 1.2s infinite`,
}, ({ delay }) => {
    return {
        animationDelay: delay,
    };
});
const Skeleton = ({ children }) => {
    return ((0, jsx_runtime_1.jsxs)(SkeletonContainer, Object.assign({ "data-testid": "video skeleton" }, { children: [(0, jsx_runtime_1.jsxs)(layout_1.Row, Object.assign({ my: 1, alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(BlinkingDot, { delay: "0s" }), (0, jsx_runtime_1.jsx)(BlinkingDot, { delay: ".2s" }), (0, jsx_runtime_1.jsx)(BlinkingDot, { delay: ".4s" })] })), children] })));
};
exports.Skeleton = Skeleton;
//# sourceMappingURL=skeleton.js.map